module.exports = __webpack_public_path__ + "img/disc-new-2x.a896a4b2.png";